import React from "react";
import { EnrichedConnection, ListingWithDetails } from "../../types";
import { ConnectionRowInner } from "./ConnectionRowInner";

interface ConnectionRowProps {
  enrichedConnection: EnrichedConnection;
  onClick?: (item: ListingWithDetails) => void;
}

export const ConnectionRow: React.FC<ConnectionRowProps> = ({
  enrichedConnection,
  onClick,
}) => {
  return (
    <ConnectionRowInner
      enrichedConnection={enrichedConnection}
      onClick={onClick}
    />
  );
};
